import React from 'react';
import { ArrowRight, Github, Linkedin, Mail } from 'lucide-react';
import '../styles/hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-label">Hi, I'm</div>
          <h1 className="hero-title">Iannis Alb</h1>
          <h2 className="hero-subtitle">AI Student & Developer</h2>
          <p className="hero-description">
            Second-year student at Babeș-Bolyai University specializing in Artificial Intelligence.
            Passionate about building innovative solutions that make a difference.
          </p>
          
          <div className="hero-cta">
            <button onClick={scrollToContact} className="btn-primary">
              Get In Touch <ArrowRight size={20} />
            </button>
            <a href="#projects" className="btn-secondary">
              View My Work
            </a>
          </div>

          <div className="hero-social">
            <a href="https://github.com/Iannis863" target="_blank" rel="noopener noreferrer" className="social-link">
              <Github size={22} />
            </a>
            <a href="https://www.linkedin.com/in/iannis-alb-502791354/" target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin size={22} />
            </a>
            <a href="mailto:iannisalb007@gmail.com" className="social-link">
              <Mail size={22} />
            </a>
          </div>
        </div>

        <div className="hero-image">
          <div className="hero-image-container">
            <img src="/iannis-headshot.jpg" alt="Iannis Alb" className="hero-profile-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;